// v2.6 QoL — central custom-keybind resolver. Reads from localStorage on demand.
// Components import getBind(action) or the KEYBINDS constant. The Settings page
// writes to localStorage; a `storage` event fires on rebind so other tabs update too.

export const DEFAULT_KEYBINDS = {
  endTurn: 'e',
  undo: 'u',
  toggleLog: 'z',
  openDeck: 'd',
  openMap: 'm',
  pause: ' ',
  cheatsheet: '?',
};

export function getKeybinds() {
  try {
    const stored = JSON.parse(localStorage.getItem('friendslop.keybinds') || '{}');
    return { ...DEFAULT_KEYBINDS, ...stored };
  } catch (e) { return { ...DEFAULT_KEYBINDS }; }
}

export function getBind(action) {
  return getKeybinds()[action] || DEFAULT_KEYBINDS[action];
}

// Case-insensitive match. Handles Space key ('  ' vs ' ') and shift+? for cheatsheet.
export function matchBind(action, event) {
  const target = getBind(action);
  if (!target) return false;
  if (target === ' ' && event.key === ' ') return true;
  if (target === '?' && (event.key === '?' || (event.shiftKey && event.key === '/'))) return true;
  return event.key.toLowerCase() === (target || '').toLowerCase();
}
